import { Component, OnInit } from '@angular/core';
import { SecureLinkAuthenticationGuard } from 'src/app/Service/secureLinkAuthentication.guard';
import { HelperService } from 'src/app/utils/helper.service';

@Component({
    selector: 'app-secure-link-access',
    templateUrl: './secure-link-access.component.html',
    styleUrls: ['./secure-link-access.component.css'],
    standalone: false
})
export class SecureLinkAccessComponent implements OnInit {
  fileInfo: any = {};
  docloaded = false;
  imgLoaded = false;
  constructor(
    public secureLinkAuthenticationGuard: SecureLinkAuthenticationGuard,
    private helper: HelperService
  ) { }
  ngOnInit(): void {
    this.fileInfo = {
      message: this.secureLinkAuthenticationGuard.info.message,
      url: this.secureLinkAuthenticationGuard.info.uri,
      isVideo: this.helper.isVideo(
        this.secureLinkAuthenticationGuard.info.extension
      ) || this.helper.isAudio(
        this.secureLinkAuthenticationGuard.info.extension
      ),
      isImage: this.helper.isImage(
        this.secureLinkAuthenticationGuard.info.extension
      ),
      isPdf: this.helper.isPdf(
        this.secureLinkAuthenticationGuard.info.extension
      ),
    };
  }
}
